export enum language {


    //buttonPanel TEXT----------------------
      buttonPanelText_1 = "BET",
    // buttonPanelText_2 = "20",
     buttonPanelText_3 = "BALANCE",
    // buttonPanelText_4 = "30",
    // buttonPanelText_5 = "WIN",
    // buttonPanelText_6 = "1450",
    // buttonPanelText_7 = "COIN VALUE",
    // buttonPanelText_8 = "$1.00",
    // buttonPanelText_9 = "MAX",
    // buttonPanelText_10 = "BET",
    // buttonPanelText_11 = "AUTO",
    // buttonPanelText_12 = "PLAY",
    // buttonPanelText_13 = ":",
    // buttonPanelText_14 = "$0.01",
    // buttonPanelText_15 = "$30.00",
    // buttonPanelText_16 = "$1,450.00",
    // buttonPanelText_17 = "0.01",
    // buttonPanelText_18 = "STOP",
    // buttonPanelText_19 = "AUTO-PLAY",
    // MobViewButtonPanelText1 = "$120.000,00",
    // MobViewButtonPanelText2 = "$200.000,00",
    // MobViewButtonPanelText3 = "$100,00",
    buttonPanelText_totalWin = "TOTAL WIN",


    //AUTOPLAY TEXT--------------------------------------------------------
    // autoplayText_1 = "AUTOPLAY SETTING",
    // autoplayText_2 = "Stop autoplay",
    // autoplayText_3 = "On any win",
    // autoplayText_4 = "If free spin are won",
    // autoplayText_5 = " AUTO",
    // autoplayText_24 = "PLAY",
    // autoplayStopText_5 = "STOP-AUTO\n     PLAY",
    // autoplayText_6 = "If single win exceeds",
    // autoplayText_7 = "If balance increase by",
    // autoplayText_8 = "If balance decrease by",
    // autoplayText_9 = "5",
    // autoplayText_10 = "10",
    // autoplayText_11 = "15",
    // autoplayText_12 = "20",
    // autoplayText_13 = "30",
    // autoplayText_14 = "40",
    // autoplayText_15 = "50",
    // autoplayText_16 = "75",
    // autoplayText_17 = "100",
    // autoplayText_18 = "0.00",
    // autoplayText_19 = "120.00",
    autoplayText_20 = "START",
    autoplayText_21 = "CANCEL",
    autoplayText_22 = "START AUTOPLAY",
    autoplayText_23 = "Cancel",
    //autoplayText_25 = "Advanced Settings",
    LossLimit_txt = 'Loss Limit',
    winLimit_txt = 'Win Limit',
    singleWinLimit_txt = 'Single Win Limit',
    option1 = "None",
    option2 = "5xbet",
    option3 = "10xbet",
    option4 = "20xbet",
    option5 = "50xbet",



    //DESKTOP SETTING PANEL---------------------------
    // desktopSettingPanel_Text_1 = "SETTINGS",
    // desktopSettingPanel_Text_2 = "Show Intro Screen",
    // desktopSettingPanel_Text_3 = "Full Screen",
    // desktopSettingPanel_Text_4 = "SOUND SETTINGS",
    // desktopSettingPanel_Text_5 = "Music",
    // desktopSettingPanel_Text_6 = "SPIN SETTINGS",
    // desktopSettingPanel_Text_7 = "Press Space Bar to Spin",
    // desktopSettingPanel_Text_8 = "Turbo Spin",

    //MOBILE VIEW PANEL TEXT-----------------------------
    // mobViewPanel_Text_1 = "BET",
    // mobViewPanel_Text_2 = "PAYTABLE",
    // mobViewPanel_Text_3 = "Setting",
    // mobViewPanel_Text_4 = "Rules",
    // mobViewPanel_Text_5 = "Autoplay",
    // mobViewPanel_Text_6 = "Bet",


    //MENU TEXT--------------------------------------------------------------
    // menuText_1 = "TOTAL BET",
    // menuText_2 = "QUICK SPIN",
    // menuText_3 = "AMBIENT MUSIC",
    // menuText_4 = "SOUND FX",
    // menuText_5 = "PLEASE SELECT YOUR COIN VALUE:",
    // menuText_6 = "Please Select Your Coin Value:",
    // menuText_7 = "CONTINUE",
    // menuText_8 = "0.01",
    // menuText_9 = "0.05",
    // menuText_10 = "0.07",
    // menuText_11 = "0.1",
    // menuText_12 = "0.5",
    // menuText_13 = "0.7",
    // menuText_14 = "1",
    // menuText_15 = "2",

    //LOADER TEXT--------------------
    // loaderText_1 = "loading",
    // loaderText_2 = "Complete!!",

    //INTRODUCTION PAGE TEXT------------------------------------------------------
    continueIntroText = "CONTINUE",
    // introductionText_1 = "FREE SPINS",
    // introductionText_2 = "UNLIMITED",
    // introductionText_3 = "WIN MULTIPLIER",
    // introductionText_4 = "WIN REACTIONS",
    // introductionText_5 = "EVERY WIN",
    // introductionText_6 = "TRIGGERS A REACTION!",
    // introductionText_7 = "WIN UP TO 10.000X YOUR TOTAL BET",


    //PAYTABLE PAGE TEXT---------------------------------------------------------------
    paytableHeading1 = "SYMBOLS",
    paytableHeading2 = "PAYTABLE",
    paytableHeading3 = "SCATTER WILD",
    paytableHeading4 = "EXPANDING RAINBOW WILD",
    paytableHeading5 = "FREE SPINS",
    paytableHeading6 = "PAY VALUES",

    firstSlideText1 = "1x",
    firstSlideText2 = "2x",
    firstSlideText3 = "3x",
    firstSlideText4 = "4x",
    firstSlideText5 = "5x",
    firstSlideText6 = "6x",
    firstSlideText7 = "0.2",
    firstSlideText8 = "0.4",
    firstSlideText9 = "0.6",
    firstSlideText10 = "0.25",
    firstSlideText11 = "0.75",
    firstSlideText12 = "0.5",
    firstSlideText13 = "1.5",
    firstSlideText14 = "1.75",
    firstSlideText15 = "50",
    firstSlideText16 = "25",
    firstSlideText17 = "10",
    firstSlideText18 = "7.5",
    firstSlideText19 = "2.5",
    firstSlideText20 = "0.8",
    firstSlideText21 = "0.1",
    //firstSlideText22 = "All wins begin with leftmost reel and pay left to right on consecutive reels.\nPayouts shown are dynamic and changing your stake will display the cash returned on each symbol.",
    firstSlideText23 = "0.15",
    firstSlideText24 = "0.9",

    secondSlideText1 = "6x",
    secondSlideText2 = "5x",
    secondSlideText3 = "4x",
    secondSlideText4 = "3x",

    thirdSlideText1 = "SYMBOLS",
    //thirdSlideTextHead2 = "SCATTER",
    //thirdSlideText2 = "Scatter appears on all reels except the Horizontal reel.\nGetting 4 or more Scatter symbols awards Free Spins.\nMore details in help file.",
    //thirdSlideText3 = "Wild",
    //thirdSlideText4 = "Wild symbols substitute for all other symbols, except Scatters.\nWilds appears only on vertical reels 2, 3, 4 and 5.",

    forthSlideText1 = "If two wilds appear on reels 2 and 5 at the same time, then they activate\nthe super rainbow and create other wilds on the reels in between them.",
    forthSlideText2 = "GET FOUR FIRE SCATTERS TO WIN 12 FREE SPINS.",

    forthSlideText3 = "If two wilds appear on reel 2 & 5 at the same time, then they expand\nand create other Wilds on the reels in between them.",
    //fifthSlideText0 = "SUPER RAINBOW",


    //fifthSlideText1 = "FREE SPINS MULTIPLIER",
    fifthSlideText2 = "Getting 4, 5, 6 Scatter symbols will award 12, 14, 16 Free Spins respectively.",
    fifthSlideText3 = "During Free Spins the appearance of a Scatter symbol awards +1 extra Free Spin.",
    fifthSlideText4 = "Free Games does not retrigger but the appearance of a scatter gives +1 extra Free Spins.",

    //fifthSlideText6 = "The Multiplier in Free Spins increases with each Tumble and remains or the remaining Free Spins.",


    //sixthSlideText1 = "LOCKED REEL",
    sixthSlideText3 = "During Free Spins, reels will lock at 7 symbols for the remaining Free Spins.",
    sixthSlideText4 = "When a reel locks it awards 1 additional Free Spin.",

    //seventhSlideText1 = "PAYTABLE",
    //seventhSlideText2 = "Reels 1 and 6 effectively have up 2-7 symbols,\nReels 2, 3, 4, and 5 effectively have 3-8 symbols.\nHorizontal Reel has 4 symbols below reels 2, 3, 4, and 5.",
    seventhSlideText3 = "Each spin may have up to \n200704 Megaways to win!",
    //seventhSlideText4 = "Winning combinations are awarded adjacent left\nto right with matching symbols regardless of size.",

    //WIN CELEBRATION----------------------------------------------------------------------
    winCelebration_bigWin = "BIG WIN",
    winCelebration_superWin = "SUPER WIN",
    winCelebration_megaWin = "MEGA WIN",
    winCelebration_legendaryWin = "LEGENDARY  WIN",

    //Intro Screen Texts----------------------------------------------------------------------
    start_btn = 'START',
    freeSpinAward = 'FREE SPINS AWARDED',
    introtext_1 = 'UNLIMITED WIN \n MULTIPLIER',
    introtext_2 = 'THE WIN MULTIPLIER BEGINS \n AT ONE AND INCREASES AFTER \n EVERY REACTION',
    introtext_3 = '3 OR MORE SCATTERS WINS \n EXTRA FREE SPINS!',
    introtext_4 = '12',




    //Outro Screen Texts----------------------------------------------------------------------

    outrotext_1 = 'CONGRATULATIONS!',
    outrotext_2 = 'YOU WON',
    outrotext_3 = '00',

    //FREEGAME TEXT----------------------------------------------------------------------
    freegameText1 = "FREE GAME",
    freegameText2 = "0",
    freegameText_out = "out",
    freegameText3 = "of",
    freegameText4 = "12",
    freegameText5 = "TOTAL WIN",
    freegameText6 = "20500",
    multiwaysText = "117649",
    freegameText7 = "MULTIPLIER",

    //Post intro texts

    intro_wildtext = "WILD SYMBOL",
    intro_scattertext = "SCATTER SYMBOL",
    //intro_wildtext2 = "Wild symbols substitute for all other\n symbols, except Scatters. Wilds appears\nonly on vertical reels 2, 3, 4 and 5.",
    intro_wildtext3 = "EACH SPIN MAY HAVE UP TO",
    intro_wildtext4 = "Scatter appears on all reels\nexcept the Horizontal reel.",
    //lockedReelPage2 = "LOCKED REEL",
    //displayOnLoadText = "Display on Load",
    //UnlimitedMultiplierPage2 = "FREE SPINS MULTIPLIER",
    lockedReelText = "During Free Spins, reels\n will lock at 7 symbols for\n the remaining Free Spins.",
    //unlimitedMulText = "The Multiplier in Free Spins\n increases with each Tumble and remains\nor the remaining Free Spins.",

    // General Setting Page

    //soundText = "Sound Effects",
    //bgMusicText = "Background Music",
    showhelpText = "Show Help Screen in Load",
    //displayCoinText = "Display in Coins",
    //quickSpinText = "Quickspin Mode",
    switchControlText = "Switch Control Side",
    //pressSbacebarText = "Press Spacebar to Spin",

    // Autoplay Setting Page

    stopOnWinText = "Stop On Any Win",
    stopfeaturetriggeredText = "Stop When Feature Triggered",
    singleWinLimitText = "Single Win Limit",
    winLimitText = "Win Limit",
    //lossLimitText = "Loss Limit",

    //SettingsGuide

    RuleTxt = "Rules",
    rulesDescription1 = "This game has an average RTP of 96.13%",
    rulesDescription2 = "Super Rainbow Megaways™ is a 6-reel, 2 to 7-row video slot. There are 4 symbols on a Horizontal reel under reels 2, 3, 4, and 5. Win Ways can be anywhere from 324 to 200704. Features include; Wilds, Super Rainbow feature, Tumbles, Free Spins with incremental multipliers, and Locked Reels.",
    rulesDescription3 = "You play a fixed 20 coins per spin, the total bet value is shown on the bet control.",
    winwaystext1 = "Mega WaysTM",
    winwaystext2 = "Winning combinations and payouts are made according to the paytable.",
    winwaystext3 = "Wins are calculated by: counting the number of consecutive reels, starting on the leftmost reel, with the number of matching symbols and multiplying the relative multiplier, shown in the paytable, by the product of the number of matching symbols on each reel.",

    tumblestext1 = "Tumbles",
    tumblestext2 = "Whenever a win way pays out, the symbols are destroyed and other symbols tumble in to replace them.",
    tumblestext3 = "All destroyed symbols are replaced with random symbols.",
    tumblestext4 = "If the new symbols also form a win way, they too will pay out and more symbols will tumble in to replace them. This will continue until no more Win Ways can be made.",

    horizontalReelstext1 = "Horizontal reel",
    horizontalReelstext2 = "There is an additional Horizontal Reel set at the bottom of reels 2,3,4,5.",
    horizontalReelstext3 = "The Horizontal Reel adds to the win ways.",
    horizontalReelstext4 = "On the Horizontal Reel, Tumbles go from right to left.",

    wildsDescription0 = "Wilds",
    wildsDescription1 = "Wilds can appear on reels 2, 3, 4, and 5 during base game and Free Spins.",
    wildsDescription2 = "Wilds cannot appear on the Horizontal Reel.",
    wildsDescription3 = "Wilds substitute for all except the scatter symbols.",

    //scattertext1 = "Scatter",
    scattertext2 = "Scatters appear on all vertical reels during normal play and on the horizontal reel during Free Spins.",
    scattertext3 = "4, 5 or 6 Scatters award 12, 14 or 16 Free Spins, respectively.",
    scattertext4 = "Can appear on spin and tumbles, during base game.",
    scattertext5 = "Appearance of a Scatter symbol during Free Spins awards +1 Free Spin.",

    //randomwildDescription0 = "Super Rainbow",
    randomwildDescription1 = "At least one Wild symbol on both reels 2 and 5 will award one extra Wild on both reel 3 and 4.",
    randomwildDescription2 = "There is a maximum of 1 wild that can appear on the reel 3 or 4 at any one time.",

    //fgmultiplierDescription0 = "Free Spins Multiplier",
    fgmultiplierDescription1 = "Free Spins have an incremental Multiplier that persists through Free Spins.",
    fgmultiplierDescription2 = "Free Spin Multiplier will increase +1 with each tumble during entire Free Spin session.",

    lockedReeltext1 = "Locked reel",
    lockedReeltext2 = "Only appears in Free Spins.",
    lockedReeltext3 = "During free spins, reels will lock at 7 symbols for the remaining Free Spins.",
    lockedReeltext4 = "When a reel locks it awards 1 additional Free Spin.",
    lockedReeltext5 = "Locked reels may appear simultaneously.",
    lockedReeltext6 = "Any of the reels can turn into locked reels.",

    additionaltext1 = "Additional Information",
    additionaltext2 = "The Maximum pay out for the game is 00,000x stake.",
    additionaltext3 = "If Maximum payout is reached, all remaining Free Spins and tumbles will stop and the Maximum payout will be awarded.",
    additionaltext4 = "Base game and Free Spins have different reel sets.",
    additionaltext5 = "For more information on the procedures used to manage unfinished game rounds, refer to the gaming website.",
    additionaltext6 = "For more information on the time after which inactive game sessions automatically end, refer to the gaming website.",
    additionaltext7 = "In the event of malfunction of the gaming hardware/software, all affected game bets and payouts are rendered void and all affected bets refunded.",
    additionaltext8 = "Last updated dd/mm/yyyy",
    additionaltext9 = "V 0.0000.00.0",

    buyfreespintext1 = "Buy Free Spins",
    buyfreespintext2 = "The average Return To Player for the Buy Free Spins feature, 12 Free Spins option is 00.00%.",
    buyfreespintext3 = "The average Return To Player for the Buy Free Spins feature, 12 Free Spins with one Locked Reel is 00.00%.",
    buyfreespintext4 = "The Maximum pay out for the Buy Free Spins feature is 00,000x stake.",
    buyfreespintext5 = "This menu allows you to select between 2 options to purchase Free Spins. You can choose between the 12 Free spins, or you can choose to buy 12 Free Spins with one Locked Reel.",
    buyfreespintext6 = "You can back out of buying the feature at any point up until you have confirmed it.",

    // Control Page Text
    //SpinText = 'Spin',
    //Spin_control_txt = 'Place a bet and begin spinning the reels, and stop spinning the reels',
    //AutoplayText = 'Autoplay',
    //Autoplay_control_txt = 'Display autoplay controls. Start and Stop autoplay',
    //BetText = 'Bet Control',
    //Bet_control_txt = 'Display stake input controls',
    //MenuText = 'Menu',
    //Menu_control_txt = 'Show and hide the menu',
    //SoundText = 'Sound',
    //Sound_control_txt = 'Mute and unmute in-game audio',
    //PaytableText = 'Paytable',
    //Paytable_control_txt = 'View symbol payouts and winning combinations',
    //BetHistoryText = 'Bet History',
    //BetHistory_control_txt = 'View previous bet details',
    //SettingsText = 'Settings',
    //GameGuideText = 'Game Guide',
    //GameGuide_control_txt = 'View the help file and in-game control descriptions',
    //Buy_Feature_Headig = 'Buy A Feature',
    //Buy_Feature_control_txt = 'View the buy a feature menu',
    //generalText = 'General',

    //FG Intro Text
    congrats = 'CONGRATULATIONS!',
    youve = `YOU'VE JUST WON`,
    youwon = `YOU HAVE WON`,
   // freespins = `FREE SPINS`,


    //Active sound screen---------------------------------------------------------------
    // activeSound = "Active sounds?",
    // soundActiveTrueText = "Yes",
    // soundActiveFalseText = "No",
}
// import ApiService from "./../../../../gameservice/api.service"
// export let language: any = {

// }

// let allLang: any = []
// let Result: any = {}
// function sendLanguageResponse(): any {
//     let url = "https://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/lang/common/en.json";
//     const api = new ApiService(url);

//     return api.get(url, {});

// }
//  Result = sendLanguageResponse();

//  Result = Result
//     .then((result: any) => { console.log("yahoo 1 lang", result.data);allLang=result.data; return result.data; })
//     .catch((error: any) => { console.error(error); return Promise.reject(error); });

// let Result_2: any = {}
// function sendLanguageResponse2(): any {
//     let url = "https://www.1x2-cloud-1.com/f1x2games/properties/BONANZA/lang/superrainbowmegaways/en.json";
//     const api = new ApiService(url);

//     return api.get(url, {});

// }


// Result_2 = sendLanguageResponse2()
//     .then((result: any) => { console.log("yahoo 1 lang", result.data); return result.data; })
//     .catch((error: any) => { console.error(error); return Promise.reject(error); });;

 // language = Result;
